export const excludeTrucksForHere = (dmEngine: string) => (category: string) =>
	dmEngine === 'here' ? category !== 'truck' : true;
